document.addEventListener("DOMContentLoaded", () => {
  // Function to update padding based on screen size
  const updatePadding = () => {
    if (window.innerWidth < 768) {
      const gridLocationPickers = document.querySelectorAll(".grid-locations-picker");

      gridLocationPickers.forEach((picker) => {
        // Find the nearest container-md above the current grid-location-picker
        let currentElement: HTMLElement | null = picker as HTMLElement;
        while (currentElement) {
          currentElement = currentElement.parentElement as HTMLElement;
          if (currentElement && currentElement.classList.contains("col-md-12")) {
            // Remove padding-left and padding-right
            currentElement.style.paddingLeft = "0";
            currentElement.style.paddingRight = "0";
            break; // Stop once the container-md is found and modified
          }
        }
      });
    } else {
      // If the screen size is not less than 768px, reset the padding if necessary
      const containerMdElements = document.querySelectorAll(".col-md-12");
      containerMdElements.forEach((container) => {
        (container as HTMLElement).style.paddingLeft = "";
        (container as HTMLElement).style.paddingRight = "";
      });
    }
  };

  // Run the function initially
  updatePadding();

  // Add a resize event listener to update padding dynamically
  window.addEventListener("resize", updatePadding);
});
